export default function _pipe(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_pipe.js
// module id = 680
// module chunks = 25